import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminPlans from './subscriptions/AdminPlans';

const AdminSubscriptionPlansPage = () => (
  <AdminLayout>
    <AdminPlans />
  </AdminLayout>
);

export default AdminSubscriptionPlansPage;
